'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Settings = {
  'development': {
    serviceUrl: 'http://localhost:3000',
    stripePublishableKey: 'pk_test_s3RWNymojOwt59kMs1ljRLcq'
  },

  'uat': {
    serviceUrl: 'https://api-uat.continuouscoaching.ca',
    stripePublishableKey: 'pk_test_s3RWNymojOwt59kMs1ljRLcq'
  },

  'production': {
    serviceUrl: 'https://api.continuouscoaching.ca',
    stripePublishableKey: 'pk_live_un9zhV8gqltWXyWLCHZ0qMs0'
  }
};

exports.default = Settings;